import styled from "styled-components";
import C from "@assets/themes/colors";
import D from "@assets/themes/dimensions";

export const Root = styled.div`
  position: fixed;
  top: ${D.APP_BAR_HEIGHT + D.COMMAND_BAR_HEIGHT + 38}px;
  left: ${D.TOOL_BAR_WIDTH + D.PICKER_BOX_WIDTH + 12}px;
  width: 323px;
  padding: 14px 0px;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: ${C.WHITE};
  z-index: 100;
`;

export const Title = styled.div`
  font-size: 18px;
  padding: 15px 28px;
`;

export const OptionRow = styled.div`
  flex: 1;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0px 25px;
  cursor: pointer;
  &:hover {
    background-color: ${C.LIGHTEST_GRAY};
  }
`;

export const OptionIcon = styled.div`
  width: 30px;
  display: flex;
  justify-content: center;
`;

export const OptionLabel = styled.span`
  margin-left: 20px;
  font-size: 15px;
`;

export const Divider = styled.div`
  margin: 5px 28px;
  flex: 1;
  height: 1px;
  background-color: rgba(32, 64, 120, 0.2);
`;

